import {createAction, createSlice, PayloadAction} from "@reduxjs/toolkit";
import {getActionName} from "../../utils/getActionName";
import {invertCard} from "../utils/invertCard";
// import {markupFormatter} from "../../common";

const sliceName = 'addCard';

export interface AddCardStore {
    markup: string;
    invertedMarkup: string;
    addInverted: boolean;
    images: Record<number /* imageId */, string /* dataUrl */>;
    uploadInProgress: boolean;
}

const defaultIcon = '{icon-gr}';

export const addCardInitialState: AddCardStore = {
    markup: `${defaultIcon}

{hint}

{answer}

{tags}
`,
    invertedMarkup: '',
    addInverted: false,
    images: {},
    uploadInProgress: false,
}

export interface PutImagePayload {
    imageId: number,
    dataUrl: string,
}

const addCardSlice = createSlice({
    name: sliceName,
    initialState: addCardInitialState,
    reducers: {
        reset(state: AddCardStore, action: PayloadAction<string>) {
            const icon = action.payload;
            if (icon !== '') {
                return {
                    ...addCardInitialState,
                    markup: addCardInitialState.markup.replace(defaultIcon, `{icon-${icon}}`)
                }
            }
            return addCardInitialState;
        },

        setMarkup(state: AddCardStore, action: PayloadAction<string>) {
            state.markup = action.payload;
        },

        setInvertedMarkup(state: AddCardStore, action: PayloadAction<string>) {
            state.invertedMarkup = action.payload;
        },

        toggleAddInverted(state: AddCardStore) {
           state.addInverted = !state.addInverted;
           if (state.addInverted) {
               state.invertedMarkup = invertCard(state.markup);
           }
        },

        putImage(state: AddCardStore, action: PayloadAction<PutImagePayload>) {
            state.images[action.payload.imageId] = action.payload.dataUrl;
        },

        setUploadInProgress(state: AddCardStore, action: PayloadAction<boolean>) {
            state.uploadInProgress = action.payload;
        },
    }
});

export interface AddImagePayload {
    dataUrl: string;
    cursorPosition: number;
}

export const addCardReducer = addCardSlice.reducer;
export const addCardActions = {
    ...addCardSlice.actions,
    addImage: createAction<AddImagePayload>(getActionName(sliceName, 'addImage')),
    uploadCard: createAction(getActionName(sliceName, 'uploadCard')),
}
